/*
 constants related to API endpoints, such as base URLs, 
 route paths, API error codes, request methods, or response statuses.
*/

// methods
export const METHODS = {
    UPDATE: 'UPDATE',
    POST: 'POST',
    GET: 'GET',
    DELETE: 'DELETE',
    PUT: 'PUT',
    PATCH: 'PATCH',
};

// headers
export const HEADERS = {
    APPLICATION_JSON: 'application/json',
    AUTHORIZATION: 'Bearer',
    X_FRONTEND_URL: 'x-frontend-url',
    X_RESET_PASSWORD_ROUTE: 'x-reset-password-route',
};

// endpoints
export const API = {
    ACCOUNT: '/account',
    ACCOUNT_HC_PLATFORM: '/account-hiring-client-platform',
    ACCOUNT_REVIEWS: '/account-review',
    ACCOUNT_USER: '/account_user',
    ADMIN: '/admin',
    ALL: '/all',
    CHANGE_STATUS: '/change-active-status',
    CHAT_MESSAGES: '/chat-messages',
    CHATS: '/chats',
    CUSTOMER_DETAIL: '/customer/detail',
    CUSTOMER_ENDPOINT: '/customer',
    CUSTOMER_FEEDBACK: '/customer-feedback',
    CUSTOMER_LOGIN: '/user/login',
    CUSTOMER_MERGE: '/customer/merge',
    DIGITAL_DELIVERY: '/digital-delivery',
    DIGITAL_LABOR_POSTER: '/digital-labor-poster',
    DOCUMENT_CATEGORY: '/document-category',
    DOCUMENT_REQUEST: '/document-request',
    DOCUMENT_UPLOAD: '/document-upload',
    FETCH_CODE: '/fetchCode',
    GRADE: '/grade',
    HIDDEN_HIRING_CLIENT: '/hidden-hiring-client',
    HIRING_CLIENTS: '/hiring-client',
    IMPERSONATE: '/impersonate',
    LOGIN: '/login',
    MY_DOCUMENTS: '/my-documents',
    MY_FOLDERS: '/my-folders',
    NEWS_FEED: '/news-feed',
    NOTIFICATION: '/notification',
    ONLINE_USERS: '/online-users',
    ORDER: '/order',
    OVERVIEW: '/overview',
    PLATFORM: '/platform',
    REFRESH_TOKEN: '/refresh-token',
    REGULATORY: '/regulatory',
    REPORT: '/report',
    COMPLIANCE: '/compliance',
    COMPLIANCE_STATUS: '/compliance/status',
    RESET_INITIATE: '/reset-initiate',
    RESET_PASSWORD: '/reset-password',
    SAFETY_MEETING_ASSOCIATIONS: '/safety-meeting-associations',
    SAFETY_MEETINGS: '/safety-meetings',
    SCORECARD: '/scorecard',
    SCORECARD_EMAIL_LOG: '/scorecard-email-log',
    SIGNED_DD_URL: '/digital-delivery/signed-url',
    SIGNED_DLLP_URL: '/digital-labor-poster/signed-url',
    SIGNED_MD_URL: '/my-documents/signed-url',
    SIGNED_SM_URL: '/safety-meetings/signed-url',
    SIGNED_URL: '/signed-url',
    USER: '/user',
    USER_LOGINS: '/user-logins',
    USER_NOTIFICATION_PREFERENCES: '/user-notification-preferences',
    USER_PAGE_VISITS: '/user-reports/user-page-visits',
    USER_REPORT_EXCEL: '/user-reports/user-report-excel',
    VALIDATE_RESET_LINK: '/validate-reset-link'
};

export const HTTP_CODES = {
    INVALID_TOKEN: 498,
    INTERNAL_SERVER_ERROR: 500,
};

export const QUERY_STALE_TIME = {
    FIVE_MIN : 300_000,
    TEN_MIN: 600_000,
    FIFTEEN_MIN: 900_000,
    THIRTY_MIN: 1_800_000,
    ONE_HOUR: 3_600_000,
}